// Gets the Tier's form ID based on the Activity's name
// NOTE: This catches any "predefined" benchmarks, all others use Benchmark 791
/**
 * Maps Activity names to their predefined Benchmark Form IDs.
 * Form IDs reference specific forms in the FOF system.
 * Default: 791 (Basic Benchmark form)
 * 
 * To add a new predefined benchmark:
 * 1. Add the mapping here (Activity Name → Form ID)
 * 2. Update allowedTiers in BenchmarkService.cs
 */
export const GetTierIdFromActivityName = (activityName: string): string => {
    switch (activityName.toUpperCase()) {
        case 'MV TERMINATIONS':
            return '1402'; // Predefined Benchmark form
        case 'SPLICE CONDUCTOR MV':
            return '1403'; // Predefined Benchmark form
        case 'RISER TERMINATIONS':
            return '1404'; // Predefined Benchmark form
        case 'SINGLE PASS TRENCHING':
            return '3944'; // Predefined Benchmark form
        case 'OPEN LAY TRENCHING/CABLE INSTALL':
            return '3945'; // Predefined Benchmark form
        default:
            return '791' // Basic Benchmark form
    };
};